import { createAsyncThunk } from '@reduxjs/toolkit';
import { entryApi } from '../apis/entry.api';
import { actions } from '../actions/entry.action';
import { ResultError } from 'modules/common';
import {
  ReqEntries,
  ReqEntryHistoryUser,
  ResEntries,
  ResEntryHistoryUser,
  ResEntryStatistics,
  ResEntryWeekly
} from '../models/entry.model';
import qs from 'qs';

export const getDailyEntryStatistics = createAsyncThunk(
  actions.GET_ENTRY_DAILY_STATISTICS,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await entryApi.getDailyStatisticsEntry(data);

      if (!res || !res.code || res.code !== 200) {
        const error = 'getDailyEntryStatistics:: api call failed ' + res;
        console.error(error);
        return rejectWithValue(error);
      } else {
        return fulfillWithValue(res);
      }
    } catch (err) {
      rejectWithValue(err);
    }
  }
);

export const getWeeklyEntryStatistics = createAsyncThunk(
  actions.GET_ENTRY_WEEKLY_STATISTICS,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await entryApi.getWeeklyStatisticsEntry(data);

      if (!res || !res.code || res.code !== 200) {
        const error = 'getWeeklyEntryStatistics:: api call failed ' + res;
        console.error(error);
        return rejectWithValue(error);
      } else {
        return fulfillWithValue(res);
      }
    } catch (err) {
      rejectWithValue(err);
    }
  }
);

/** 사용자 개인의 출역 이력 페이지 조회 API thunk 입니다. */
export const getEntryHistoryUser = createAsyncThunk<
  ResEntryHistoryUser,
  ReqEntryHistoryUser,
  {
    rejectValue: ResultError;
  }
>(actions.GET_ENTRY_WEEKLY_STATISTICS, async (data, { fulfillWithValue, rejectWithValue }) => {
  try {
    const res = await entryApi.getEntryHistoryUser(data);

    return fulfillWithValue(res);
  } catch (error) {
    const err = error as ResultError;

    return rejectWithValue(err);
  }
});

/**
 * 출입이력 통계 자료 조회
 */
export const getEntryStatistics = createAsyncThunk<ResEntryStatistics, string>(
  actions.GET_ENTRY_STATISTICS,
  async (entryDate, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await entryApi.getEntryStatistics(entryDate);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 출입이력 주간 통계 자료 조회
 */
export const getEntryStatisticsWeekly = createAsyncThunk<ResEntryWeekly, string>(
  actions.GET_ENTRY_STATISTICS_WEEKLY,
  async (entryDate, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await entryApi.getEntryStatisticsWeekly(entryDate);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 출입이력 목록 조회
 */
export const getEntries = createAsyncThunk<ResEntries, ReqEntries>(
  actions.GET_ENTRY_LIST,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const query = qs.stringify(data);
      const response = await entryApi.getEntryList(query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
